import styled from 'styled-components';

export const Badge = styled.span<{ bg: string }>`
  background-color: ${p => p.bg};
  color: #fff;
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: background-color 200ms ease-in-out, color 200ms ease-in-out;
`;


